import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { useNavigate } from 'react-router-dom';
import { httpGetTransactionDetails } from '../../Hooks/orders/order.hooks';
import { TransactionCompleteSection, TransactionMain } from './Course.styles';
import PageHelmet from '../../Components/PageHelmet/HelmetHelper.component';
const CompleteTransaction = () => {
  const navigate = useNavigate();
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [error, setError] = useState(null);
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get('session_id');
  // console.log('Transaction details A', transactionDetails);

  useEffect(() => {
    const FetchTransactionDetails = async () => {
      const response = await httpGetTransactionDetails(sessionId);
      if (response.ok) {
        const data = await response.json();
        // console.log('Transaction Details B:', data);
        setTransactionDetails(data?.transaction);
      } else {
        setError(
          'Failed to fetch transaction details. Please try again later.'
        );
        console.error('Failed to fetch transaction details');
      }
    };
    if (sessionId) {
      FetchTransactionDetails();
    }
  }, [sessionId]);

  return (
    <TransactionMain>
      <PageHelmet
        title="Purchase Complete"
        description="Your purchase has been completed successfully. View your order confirmation and access your purchased training."
        noIndex
      />
      <TransactionCompleteSection>
        <h2>Transaction Complete</h2>
        {error && <p>{error}</p>}
        <p>
          Thank you for your purchase! Your transaction has been successfully
          processed. You will shortly recieve an email of confirmation, if you
          do not recieve an email, please check your spam folder or contact us.
        </p>
        <p>
          <strong>Transaction ID:</strong> {transactionDetails?._id}
        </p>

        {Number(transactionDetails?.displayAmount?.discount) > 0 && (
          <p>
            <strong>Discount:</strong> $
            {Number(transactionDetails.displayAmount.discount).toFixed(2)}
          </p>
        )}
        <p>
          <strong>Currency:</strong>{' '}
          {transactionDetails?.displayAmount?.currency || 'CAD'}
        </p>
      </TransactionCompleteSection>
      <TransactionCompleteSection>
        <h4>Purchased Course(s):</h4>
        <ul>
          {transactionDetails?.items?.map((item) => {
            const itemName =
              item?.courseName ||
              item?.name ||
              item?.productName ||
              (item?.course && item.course.courseName) ||
              'Untitled item';
            const key =
              (item?.courseId && String(item.courseId)) ||
              item?._id ||
              itemName;
            return (
              <li key={key}>
                <strong>{itemName}</strong>
                {item?.quantity > 1 && <span> &times; {item.quantity}</span>}
              </li>
            );
          })}
        </ul>
      </TransactionCompleteSection>
      <TransactionCompleteSection>
        <h4>Buyer Information:</h4>
        <p>
          <strong>Name:</strong> {transactionDetails?.buyer?.name}
          <br />
          <strong>Email:</strong> {transactionDetails?.buyer?.email}
        </p>
      </TransactionCompleteSection>
      <TransactionCompleteSection>
        <h4>Order Summary:</h4>
        <p>
          <strong>Subtotal:</strong> $
          {Number(transactionDetails?.displayAmount?.total)?.toFixed(2)}
        </p>
        <p>
          <strong>Tax:</strong> $
          {Number(transactionDetails?.displayAmount?.tax)?.toFixed(2)}
        </p>
        <p>
          <strong>Total:</strong> $
          {Number(transactionDetails?.displayAmount?.grandTotal)?.toFixed(2)}
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            marginBlock: 'var(--space-xl)',
          }}
        >
          <PrimaryButtonComponent
            span="Go to Dashboard"
            functionName={() => navigate('/user')}
          />
        </div>
        <p className="m1T" style={{ textAlign: 'center' }}>
          If you have any questions about this course or need assistance,
          contact us at{' '}
          <a
            href="mailto:yodasafetyservices1@outlook.com"
            style={{
              textTransform: 'lowercase',
              letterSpacing: '0',
              color: 'var(--grey4)',
              textDecoration: 'underline',
            }}
          >
            yodasafetyservices1@outlook.com
          </a>{' '}
          or 1-902-478-1972.
        </p>
      </TransactionCompleteSection>
    </TransactionMain>
  );
};

CompleteTransaction.propTypes = {
  transactionId: PropTypes.string,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      courseId: PropTypes.string,
      courseName: PropTypes.string,
    })
  ),
  billingAddress: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    adminArea1: PropTypes.string,
    adminArea2: PropTypes.string,
    countryCode: PropTypes.string,
    postalCode: PropTypes.string,
  }),
  total: PropTypes.number,
  tax: PropTypes.number,
  grandTotal: PropTypes.number,
};

export default CompleteTransaction;
